"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRouterPure = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var connected_react_router_1 = require("connected-react-router");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var current_1 = require("@caddigital/sok-reducers/lib/actions/auth/current");
var types_1 = require("types");
//#region Grano Admin Routes
var CustomerManagement_1 = require("../views/admin/CustomerManagement");
var UserManagement_1 = require("../views/admin/UserManagement");
var CustomerWizard_1 = require("../views/admin/CustomerWizard");
var TranslationsView_1 = require("../views/admin/TranslationsView");
var ProjectWizard_1 = require("../views/admin/ProjectWizard");
var index_1 = require("../views/admin/Activity/index");
var SSOManagementListView_1 = require("../views/admin/SSOManagementListView");
var SSOManagementView_1 = require("../views/admin/SSOManagementView");
var MiscView_1 = require("../views/admin/MiscView");
var CustomerAdminManagementView_1 = require("../views/CustomerAdminManagementView");
var ManagementView_1 = require("../views/ManagementView");
//#endregion
var ProjectRouter_1 = require("./ProjectRouter");
var BriefcaseRouter_1 = require("./BriefcaseRouter");
//#region User Routes
var ProjectsOverview_1 = require("../views/ProjectsOverview");
var DashboardView_1 = require("../views/DashboardView");
var LoadingView_1 = require("../views/LoadingView");
var SubprojectsView_1 = require("views/SubprojectsView");
var BriefcaseListView_1 = require("views/BriefcaseListView");
//#endregion
var translate_1 = require("utils/translate");
var App_1 = require("../views/App");
//#region map
var mapStateToProps = function (state) {
    var hasToken = __DISABLE_LOGIN__ ||
        (state.auth.current.token && state.auth.current.token !== '');
    var firstTime = __DISABLE_LOGIN__ || !state.auth.login.firstTime;
    var user = state.auth.current.user.toNullable();
    // TODO add correct isGranoAdmin state
    return {
        isLoggedin: state.auth.login.status === 'LOGGED_IN' || __DISABLE_LOGIN__,
        userStatus: state.auth.current,
        translations: state.translations.translations,
        user: user,
        initialized: hasToken &&
            firstTime &&
            user &&
            user.status === 'VALID' &&
            state.translations.translations.status !== 'FETCHING'
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    getUserInfo: function () { return dispatch((0, current_1.getUserinfoRequestAction)()); },
    getUserFeatures: function () { return dispatch((0, current_1.fetchUserFeaturesRequest)()); },
    redirect: function (language) { return dispatch((0, connected_react_router_1.replace)("/".concat(language, "/first-time"))); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#endregion
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var adminRoutes = function (baseUrl, user) {
    var routes = [];
    switch (user ? user.level : 'NormalUserGroup') {
        case 'SuperAdminUserGroup':
            routes = __spreadArray(__spreadArray([], routes, true), [
                React.createElement(react_router_dom_1.Route, { key: 'customermanagement', exact: true, path: "".concat(baseUrl, "/admin/customermanagement"), render: function (props) { return React.createElement(CustomerManagement_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'customermanagement-add', exact: true, path: "".concat(baseUrl, "/admin/customermanagement/customer/create"), render: function (props) { return React.createElement(CustomerWizard_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'customermanagement-edit', exact: true, path: "".concat(baseUrl, "/admin/customermanagement/customer/:customerId"), render: function (props) { return React.createElement(CustomerWizard_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'usermanagement', path: "".concat(baseUrl, "/admin/usermanagement"), render: function (props) { return React.createElement(UserManagement_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'translations', path: "".concat(baseUrl, "/admin/translations"), render: function (props) { return React.createElement(TranslationsView_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'projects', path: "".concat(baseUrl, "/admin/projects/:projectId?"), render: function (props) { return React.createElement(ProjectWizard_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'activities', path: "".concat(baseUrl, "/admin/activity"), render: function (props) { return React.createElement(index_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { exact: true, key: 'sso-list', path: "".concat(baseUrl, "/admin/sso"), render: function (props) { return React.createElement(SSOManagementListView_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'sso-management', path: "".concat(baseUrl, "/admin/sso/:federation"), render: function (props) { return React.createElement(SSOManagementView_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'misc', path: "".concat(baseUrl, "/admin/misc"), render: function (props) { return React.createElement(MiscView_1.default, __assign({}, props)); } })
            ], false);
        // ts-lint-disable no-fallthrough
        case 'CustomerAdminUserGroup':
            routes = __spreadArray(__spreadArray([], routes, true), [
                React.createElement(react_router_dom_1.Route, { key: 'management', exact: true, path: "".concat(baseUrl, "/management"), render: function (props) { return React.createElement(ManagementView_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'customer-admin-management', path: "".concat(baseUrl, "/management/:id"), render: function (props) { return React.createElement(CustomerAdminManagementView_1.default, __assign({}, props)); } })
            ], false);
    }
    return routes;
};
//#region Component
var AppRouterPure = function (props) {
    var baseUrl = props.match.url;
    if (props.initialized) {
        return (React.createElement(App_1.default, null,
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { exact: true, path: "".concat(baseUrl), component: DashboardView_1.default }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: "".concat(baseUrl, "/projects"), component: ProjectsOverview_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "".concat(baseUrl, "/projects/:projectId"), render: function (props) { return React.createElement(ProjectRouter_1.ProjectRouter, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: "".concat(baseUrl, "/subprojects"), render: function (props) { return React.createElement(SubprojectsView_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: "".concat(baseUrl, "/briefcases"), render: function (props) { return React.createElement(BriefcaseListView_1.default, __assign({}, props)); } }),
                React.createElement(react_router_dom_1.Route, { key: 'briefcase', path: "".concat(baseUrl, "/briefcase/:id"), render: function (props) { return React.createElement(BriefcaseRouter_1.default, __assign({}, props)); } }),
                adminRoutes(baseUrl, props.user),
                React.createElement(react_router_dom_1.Redirect, { to: "".concat(baseUrl) }))));
    }
    return (React.createElement(react_router_dom_1.Route, { path: "".concat(baseUrl), render: function () { return (React.createElement(LoadingView_1.default, { userStatus: props.userStatus, translations: props.translations })); } }));
};
exports.AppRouterPure = AppRouterPure;
//#endregion
//#region build component
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('AppRouter'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        if (this.props.isLoggedin &&
            this.props.user === null &&
            this.props.userStatus.status !== 'FETCHING') {
            this.props.getUserInfo();
            this.props.getUserFeatures();
        }
    },
    componentDidUpdate: function () {
        if (this.props.user &&
            (this.props.user.status === 'FIRST_TIME' ||
                this.props.user.status === 'TERMS_NOT_ACCEPTED' ||
                this.props.user.status === 'MISSING_INFORMATION' ||
                this.props.user.company === null)) {
            var language = (0, translate_1.getLanguage)() || 'en';
            this.props.redirect(language);
        }
        if (this.props.isLoggedin &&
            this.props.userStatus.status !== 'FETCHING' &&
            this.props.userStatus.status !== 'FAILED' &&
            this.props.user === null) {
            this.props.getUserInfo();
            this.props.getUserFeatures();
        }
    }
}), recompose_1.pure);
//#endregion
exports.default = enhance(exports.AppRouterPure);
